import { Box, styled } from "@mui/material";

export const ErrorPageBox = styled(Box)(({ theme }) => ({
  color: theme.palette.biarri.secondary.grey,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(6),
}));
